import {Button, TextField} from '@wandb/components';
import React, {useCallback} from 'react';

import styles from './markdownProse.module.css';
import type {useWbAgentChat} from './useWbAgentChat';

type Chat = ReturnType<typeof useWbAgentChat>;

export const ChatInput: React.FC<{chat: Chat}> = ({chat}) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        chat.send();
      }
    },
    [chat]
  );

  return (
    <div
      className="flex items-center gap-6 border-t border-[#E8E8E9] bg-white p-10"
      onKeyDown={handleKeyDown}>
      <div className={`flex-1 ${styles.chatInput}`}>
        <TextField
          aria-label="Ask a question"
          placeholder="Ask a question..."
          value={chat.input}
          onChange={chat.setInput}
          isDisabled={chat.sending || chat.available !== true}
          fullWidth
          enterKeyHint="send"
        />
      </div>
      <Button
        variant="primary"
        size="sm"
        onPress={chat.send}
        isDisabled={
          chat.sending || !chat.input.trim() || chat.available !== true
        }>
        Send
      </Button>
    </div>
  );
};
